module.exports = __webpack_public_path__ + "img/titulo-registro.3c29f807.png";